var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProcedureStart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.25H15.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.25H15.75",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58455 13.1612L5.11893 16.4706C5.5902 16.9123 6.19147 17.1902 6.83334 17.2628C7.4752 17.3355 8.12336 17.199 8.68143 16.8737L22.8752 8.62368L21.1314 6.48618C20.6778 5.93218 20.041 5.55869 19.3361 5.43318C18.6312 5.30767 17.9046 5.43842 17.2877 5.8018L13.1252 8.24868L7.50018 6.37368L5.9533 7.0393C5.83758 7.0889 5.7362 7.16683 5.65851 7.26592C5.58083 7.365 5.52934 7.48205 5.50879 7.60627C5.48824 7.73049 5.4993 7.85789 5.54094 7.97671C5.58258 8.09553 5.65346 8.20196 5.74705 8.28618L8.62518 10.8737L6.00018 12.3737L3.37518 11.2487L1.80018 11.9237C1.68559 11.9729 1.58509 12.0499 1.50776 12.1478C1.43044 12.2456 1.37873 12.3612 1.35732 12.4841C1.33592 12.6069 1.34548 12.7332 1.38516 12.8514C1.42484 12.9696 1.49337 13.0761 1.58455 13.1612V13.1612Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58455 13.1612L5.11893 16.4706C5.5902 16.9123 6.19147 17.1902 6.83334 17.2628C7.4752 17.3355 8.12336 17.199 8.68143 16.8737L22.8752 8.62368L21.1314 6.48618C20.6778 5.93218 20.041 5.55869 19.3361 5.43318C18.6312 5.30767 17.9046 5.43842 17.2877 5.8018L13.1252 8.24868L7.50018 6.37368L5.9533 7.0393C5.83758 7.0889 5.7362 7.16683 5.65851 7.26592C5.58083 7.365 5.52934 7.48205 5.50879 7.60627C5.48824 7.73049 5.4993 7.85789 5.54094 7.97671C5.58258 8.09553 5.65346 8.20196 5.74705 8.28618L8.62518 10.8737L6.00018 12.3737L3.37518 11.2487L1.80018 11.9237C1.68559 11.9729 1.58509 12.0499 1.50776 12.1478C1.43044 12.2456 1.37873 12.3612 1.35732 12.4841C1.33592 12.6069 1.34548 12.7332 1.38516 12.8514C1.42484 12.9696 1.49337 13.0761 1.58455 13.1612V13.1612Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProcedureStart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/procedureStart.2558e80b4de2376b61a8be2dd051a9c8.svg";